import React, { useState } from 'react'
import ModalBody from './modal/modal-body'
import SlideEffect from '@/assets/sounds/slide.mp3'
import { projectList } from '@/data/project'
import { ProjectType } from '@/types/data'
import ProjectCard from './project-card'
import RepoTab from './repo-tab'

type Props = {}

const Project = (props: Props) => {
    const projectMenu = [
        {
            content: "Projects",
            icon: null
        },
        {
            content: "Github Repos",
            icon: null
        }
    ]
    const [menu, setMenu] = useState<string>(projectMenu[0].content)
    const [activeIndex, setActiveIndex] = useState(0)

    return (
        <ModalBody className='w-3/4'>
            <div className='relative flex flex-col gap-y-2'>
                <div className='relative'>
                    <ul className='flex'>
                        {
                            projectMenu.map((item, index: number) => (
                                <li
                                    key={index}
                                    onClick={() => {
                                        new Audio(SlideEffect).play()
                                        setMenu(item.content)
                                        setActiveIndex(index)
                                    }}
                                    className={`
                                    flex-1
                                    px-3 py-2
                                    font-bold
                                    cursor-pointer
                                    relative text-center
                                    ${item.content === menu ? 'text-blue-500' : 'text-gray-600'}
                                    `}>
                                    {item.content}
                                </li>
                            ))
                        }
                    </ul>
                    <div
                        className="absolute bottom-0 h-0.5 bg-blue-500 transition-all duration-300 ease-in-out"
                        style={{
                            width: `${100 / projectMenu.length}%`,
                            transform: `translateX(${activeIndex * 100}%)`
                        }}
                    />
                </div>
                {menu === "Projects" &&
                    <div className='flex flex-col gap-y-2'>
                        {
                            projectList.map((project: ProjectType, index: number) => (
                                <ProjectCard index={index} key={index} project={project} />
                            ))
                        }
                    </div>
                }

                {menu === "Github Repos" && <RepoTab />}

                <div className='flex justify-center items-center bottom-0 sticky'>
                    <button className='w-10 h-10 bg-blue-500/75 rounded-full text-xs text-white animate-bounce'>Scroll</button>
                </div>
            </div>
        </ModalBody>
    )
}

export default Project